import templateUrl from 'emun.on-demand/templates/od-product-template-editor.htm'
import controller from 'emun.on-demand/templates/od-product-template-editor.controller'
import resolve from 'ioc/resolve'

const ProductTemplateEditorComponent = {
    bindings: {
        productTemplate: '<?',
        productTemplateId: '@',
        title: '@',
        subTitle: '@',
        onSaved: '&',
        onCancel: '&'
    },
    require: {
        manager: '^odProductTemplateManager'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
};

export default ProductTemplateEditorComponent;